import { Component, Input, OnInit } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DirectionService } from '@services/direction.service';
import { RouterLink } from '@angular/router';
import { NgIf, NgClass, NgFor } from '@angular/common';

@Component({
    selector: 'app-block-categories',
    templateUrl: './block-categories.component.html',
    styleUrls: ['./block-categories.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, RouterLink, NgClass, NgFor, TranslateModule]
})
export class BlockCategoriesComponent implements OnInit {
    @Input() name;
    @Input() class;
    @Input() mainCategoryId;
    @Input() caption;
    @Input() image;
    @Input() categories;
    @Input() categoriesCount;
    @Input() mainCategory;
    @Input() element;


    get categoriesCountedList() {
        let list = [];
        (this.categories as []).forEach((value, index) => {
            if (index < +this.categoriesCount) {
                list.push(value);
            }
        });
        return list;
    }
    constructor(
        public translateHelper: TranslateHelper,
        public translate: TranslateService,
        public direction: DirectionService,
    ) {
    }

    ngOnInit(): void {

        if (this.element?.catGrid?.length - this.categoriesCountedList?.length) {
            this.element.catGrid = this.element.catGrid.slice(0, this.categoriesCountedList?.length - this.element?.catGrid?.length);
        }
    }
}
